








import { Mixins, Component, Prop, Watch, Emit } from "vue-property-decorator";
import { ModalPresentableMixin } from "../../../system/mixins";
import { DomainRegistry } from "../../../../domain";

@Component
export default class ReceptionDeliveryGeneralFlagEditor extends Mixins(ModalPresentableMixin) {
  @Prop({ default: null })
  detailId: number;

  @Prop({ default: false })
  generalFlag: boolean;

  @Prop({ default: "" })
  generalFlagLabel: string;

  @Emit()
  generalFlagUpdated(): void {}

  data(): any {
    return {
      edittingFlag: false,
      isUpdating: false,
    };
  }
  edittingFlag: boolean;
  isUpdating: boolean;

  mounted() {
    this.edittingFlag = this.generalFlag;
  }

  @Watch("generalFlag")
  onGeneralFlagChanged(newValue: boolean, oldValue: boolean) {
    this.edittingFlag = this.generalFlag;
  }

  async onClick() {
    if (!this.detailId) {
      return;
    }
    try {
      this.beginModal();
      const index = await this.$commonDialogs.confirmation.confirmYesNo(
        "変更確認",
        this.edittingFlag
          ? [this.generalFlagLabel + "解除しますか？"]
          : [this.generalFlagLabel + "設定しますか？"]
      );
      if (index !== 0) { return; }
      this.updateGeneralFlag(!this.edittingFlag);
    } catch {
    } finally {
      this.endModal();
    }
  }

  private updateGeneralFlag(value: boolean): void {
    this.isUpdating = true;
    const repository = DomainRegistry.workflow.getWorkflowRepository();
    repository.registerGeneralFlag1(this.detailId, value)
      .then(() => {
        this.$success("成功", this.generalFlagLabel + (value ? "設定" : "解除") + "に成功しました。");
        // 親に投げる
        this.generalFlagUpdated();
      })
      .catch(e => {
        this.$error("エラー", this.generalFlagLabel + (value ? "設定" : "解除") + "に失敗しました。", e);
      })
      .finally(() => {
        this.isUpdating = false;
      });
  }
}
